import {
  MotifProgressLoader,
} from "@ey-xd/motif-react";
import { Link, useParams } from "react-router-dom";
import { havingDeletePermission } from "@/utility/common";
import {
  GetCommonDeleteImgButton,
} from "@/components/Images/CommonImages";
type claimItemConst = {
  data: {
    creditorId: any;
    claimItemId: string;
    categoryName: string;
    originalAmt: string;
    currentAmt: string;
    latestCreditorPositionAmt: string;
    latestDebtorPositionAmt: string;
    resolvedAmt: number;
    creditorName: string;
    claimId: string;
    updatedOn: string;
    claimReference: string;
    claimItemReference: string;
    categoryId: string;
  };
  node: {
    rowPinned: boolean;
    data: {
      columnField1: React.FC;
      columnField2: React.FC;
      columnField3: React.ReactElement;
      columnField4: React.ReactElement;
      columnField5: React.ReactElement;
      columnField6: React.ReactElement;
      columnField7: React.ReactElement;
      columnField8: React.ReactElement;
    };
  };
};

export const useCustomCellRenderers = (
  caseId: undefined | string,
  setClaimItemId: any,
  setShowModal: any,
  resolvedStatus: any,
  ClaimItem: string[],
  setclaimItemReference:any
) => {
  const {  creditorId, debtorId } = useParams();

  const customActionHeader = {
    actionRenderer: function (param: any) {
      if (param.node.rowPinned) return false;
      else
        return (
          <>
            {param.data.creditorName !== undefined &&
            param.data.claimReference !== undefined &&
            param.data.updatedOn !== undefined ? (
              <>
                {/* {
                <MotifButton
                  size="small"
                  type="submit"
                  variant="secondary"
                  style={{ padding: "0px 8px" }}
                >
                  <Link
                    to={
                      `/case/${caseId}/claim/details/` +
                      param.data.claimItemId +
                      `?claimId=${param.data.claimId}&creditorName=${param.data.creditorName}&updatedOn=${param.data.updatedOn}&claimReference=${param.data.claimReference}&creditorId=${param.data.creditorId}`
                    }
                    style={{ display: "block" }}
                  >
                    <MotifIcon
                      iconFunction={IconoirEditPencil}
                      stroke="blue"
                      strokeWidth="2"
                      size="20"
                    />
                  </Link>
                </MotifButton>
              } */}
                &nbsp;&nbsp;
                {param.data.resolvedAmt === 0 || param.data.resolvedAmt === null
                  ? havingDeletePermission(ClaimItem) && (
                    <GetCommonDeleteImgButton
                         onClick={() => {
                          setClaimItemId(param.data.claimItemId);
                          setclaimItemReference(param.data.claimItemReference);
                          setShowModal(true);
                        }}
                    ></GetCommonDeleteImgButton>
                    // <CommonTooltipWrapper tooltipTitle={t("global.globalActions.delete")}>
                    //   <MotifButton
                    //     size="small"
                    //     type="submit"
                    //     variant={DELETE_IMG_VARIANT}
                    //     onClick={() => {
                    //       setClaimItemId(param.data.claimItemId);
                    //       setclaimItemReference(param.data.claimItemReference);
                    //       setShowModal(true);
                    //     }}
                    //   >
                    //     {getCommonDeleteImg()}
                    //   </MotifButton>
                    // </CommonTooltipWrapper>
                    )
                  : havingDeletePermission(ClaimItem) && (
                    <GetCommonDeleteImgButton
                    onClick={() => {
                      setClaimItemId("");
                      setShowModal(true);
                    }}
                    ></GetCommonDeleteImgButton>
                    // <CommonTooltipWrapper tooltipTitle={t("global.globalActions.delete")}>
                    //   <MotifButton
                    //     size="small"
                    //     type="submit"
                    //     variant={DELETE_IMG_VARIANT}
                    //     onClick={() => {
                    //       setClaimItemId("");
                    //       setShowModal(true);
                    //     }}
                    //   >
                    //     {getCommonDeleteImg()}
                    //   </MotifButton>
                    // </CommonTooltipWrapper>
                    )}
              </>
            ) : (
              <MotifProgressLoader variant="circular" size="xs" />
            )}
            {/* // <MotifDropdown
          //   ariaLabelledby="dropdown-trigger-1"
          //   id="dropdown-1"
          //   trigger={
          //     <MotifButton
          //       aria-label="Fruits"
          //       id="dropdown-trigger-1"
          //       onClick={function Ga() {}}
          //       type="button"
          //       variant="text"
          //     >
          //       <MotifIcon iconFunction={IconoirMoreHoriz} />
          //     </MotifButton>
          //   }
          // >
          //   <ul aria-label="fruits" role="menu">
          //     {debtorTitleMenu.map((menuName: string) => {
          //       return (
          //         <li role="menuitem">
          //           <MotifDropdownItem indexItem={1} onClick={function Ga() {}}>
          //             {menuName}
          //           </MotifDropdownItem>
          //         </li>
          //       );
          //     })}
          //   </ul>
          // </MotifDropdown> */}
          </>
        );
    },
    categoryName: function (param: claimItemConst) {
      if (param.node.rowPinned) {
        return param.node.data.columnField8;
      } else {
        return (
          
           <span > {param?.data?.categoryName}</span>
        );
      }
    },
    claimItemId: function (param: claimItemConst) {
      if (param.node.rowPinned) {
        return param.node.data.columnField1;
      } else {
        return param.data.claimItemId;
      }
    },
    claimItemReference: function (param: claimItemConst) {
      return (
        <Link
          to={
            `/case/${caseId}/claim/details/` +
            param?.data?.claimItemId +
            `?navigatedFrom=${creditorId?"creditor":debtorId?"debtor":"claim"}&navId=${creditorId?creditorId:debtorId?debtorId:param?.data?.claimId}&claimId=${param?.data?.claimId}&creditorName=${param?.data?.creditorName}&updatedOn=${param?.data?.updatedOn}&claimReference=${param?.data?.claimReference}&creditorId=${param?.data?.creditorId}`
          }
        >
         <span className="text-bold-underline"> {param?.data?.claimItemReference}</span>
        </Link>
      );
    },
  };
  return customActionHeader;
};
